import { create } from "zustand";

export const useGroupListingStore = create<IGroupListingStore>((set, _get) => ({
  view: "card",
  setView: (newView: "list" | "card") => {
    set({ view: newView });
  },
}));

export interface IGroupListingStore {
  view: "list" | "card";
  setView: (view: "list" | "card") => void;
}
